<template>
  <div></div>
</template>

<script>
import { EventBus } from './event_bus.js'

export default {
  created () {
    document.onkeydown = (event) => {
      let keyCode = event.keyCode || null
      if ([13, 38, 40, 27].includes(keyCode)) {
        EventBus.$emit('fm-key-down', keyCode)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/OnKeyDown.vue